import { getRestartVerificationRequest } from './requestCreator';
import { postRequest } from './AxiosClient';
import type { ApiResult, RestartVerificationResponse } from './types';

export const restartVerification = async (
  channel: string,
): Promise<ApiResult<RestartVerificationResponse>> => {
  const { url, headers } = getRestartVerificationRequest(channel);
  return postRequest<RestartVerificationResponse>(url, headers)
    .then((response): ApiResult<RestartVerificationResponse> => {
      if (
        response?.status == 200 &&
        typeof response.data === 'object' &&
        response?.data?.militaryDiscount
      )
        return { response };
      return { error: true };
    })
    .catch((): ApiResult<RestartVerificationResponse> => {
      // eslint-disable-next-line no-console
      console.log(
        'Error calling restart verification API, in restartVerification()',
      );
      return { error: true };
    });
};
